import PageEventsList from "pages/ma/events";

const eventRouters = [
  // path objects:
  { path: "/events", component: PageEventsList },
];

export default eventRouters;
